/**
 * Main Firebase entry point.
 * This file re-exports components from modular files for backwards compatibility
 * and initializes essential Firebase services.
 *
 * @module firebase
 */

import { app, db } from "./firebase/config";

import {
  analytics,
  initializeAnalytics,
  updateAnalyticsState,
} from "./firebase/analytics";

import { auth, setPersistentAuth } from "./firebase/auth";

import {
  setupAdminPresence,
  cleanupAdminPresence,
  stopGlobalMonitoring,
} from "./firebase/presence/web";

(async () => {
  await initializeAnalytics(app);
})();

export {
  app,
  db,
  auth,
  analytics,
  setPersistentAuth,
  setupAdminPresence,
  cleanupAdminPresence,
  stopGlobalMonitoring,
  updateAnalyticsState,
};
